import BackendService from "../core/backend/backend.service";

const AccountApiService = {
    async get() {
        return BackendService.query('account', {
            "validate": true,
        });
    },

    async summary() {
        return BackendService.get('account/summary');
    },

    settings: {
        setOption(key, value) {
            return BackendService.post('account/settings', {
                key: key,
                value: value
            });
        }
    }
}

export default AccountApiService;


